export default {
  BASE_API: 'https://app.levelupmultiverse.com/api',
  // 请求签名
  SIGN_KEY: 'dialingo.key'
};
